var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('regist-component',{on:{"on-success":_vm.onLoginSuccess,"on-login-click":_vm.onLoginClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }